import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import AuthUser from "../../../components/AuthUser";

import Spinner from "../../../components/Spinner";
import CursoFilter from "../Administration/employees/CursoFilter";
import CursoTable from "../Administration/employees/CursoTable";
import CursoModal from "../../../components/Administration/employees/CursoModal";

const Curso = () => {

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();
  const [cursos, setcursos] = useState([]);  

  const [filteredcursos, setfilteredcursos] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredcursos) => {     
    setfilteredcursos(filteredcursos); 
  };


  const handleSubmissionSuccess = (cursos) => {
    // Refresh acessos state or trigger any necessary actions
    setcursos(cursos);    
  };

  const getCursos = async () => {

    try {

      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/listar-cursos');

      setcursos(res.data.cursos);

      setLoading(false);

    } finally {

      setLoading(false); // Set loading to false when the request is complete (either success or error)

    }
  }; 
 

  useEffect(() => {

    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await getCursos();

      } catch (error) {
        console.error('Erro ao obter cursos:', error);
      }
    };

    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  if (verificarPermissao('CARGO', 'ver')) 
  if (loading) return (<><Spinner></Spinner></>); else return (
    <>
      (
      <>
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('Certificações')}
          title="Dashboard"
          subtitle={t('Tipos de certificações')}
          modal="#add_curso_modal"
          name={t('Add Certificação')}
        />
        <CursoFilter onFilterSubmit={handleFilterSubmit} />
        <CursoTable cursos={filteredcursos.length > 0 ? filteredcursos : cursos} tipo={1} />
        <CursoModal onSubmissionSuccess={handleSubmissionSuccess} tipo={1} />
      </div>
    </div> </>
        ); </>
    );
  else
    return (<>
      <div className="page-wrapper cardhead">
        <div className="content ">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SEM PERMISSÃO 2025</h3>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"><i className="fa fa-times-circle text-danger"></i>&nbsp; OPERAÇÃO NÃO AUTORIZADA</h4>
                </div>
                <div className="card-body">
                  <p>
                    Esta operação não é autorizada para o seu nivel de acesso ao sistema, por favor contacte o administrador do sistema.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>)
};


export default Curso;
